import React from 'react';
import { Icon } from '../Icon/Icon';
import { IconName } from '../Icon/Icon.type';
import { LoadingDots } from '../LoadingDots/LoadingDots';
import { Container } from '../Container/Container';

interface BGLoadingIndicatorProps {
  size?: 'sm' | 'md' | 'lg';
}

export const BGLoadingIndicator: React.FC<BGLoadingIndicatorProps> = ({ size = 'md' }) => {
  const sizeClasses = {
    sm: {
      container: 'gap-bg-v2-sm min-w-[60px] min-h-[60px]',
      padding: 'lg' as const,
      icon: 'w-[24px] h-[24px]',
      iconSize: 'md' as const
    },
    md: {
      container: 'gap-bg-v2-lg min-w-[90px] min-h-[90px]',
      padding: '2xl' as const,
      icon: 'w-[38px] h-[39px]',
      iconSize: 'xl' as const
    },
    lg: {
      container: 'gap-bg-v2-xl min-w-[120px] min-h-[120px]',
      padding: '3xl' as const,
      icon: 'w-[48px] h-[49px]',
      iconSize: 'xl' as const
    }
  };

  const classes = sizeClasses[size];

  return (
    <Container 
      variant="primary" 
      padding={classes.padding}
      className={`flex flex-col items-center justify-center ${classes.container} rounded-bg-v2-md container-shadow-lg`}
    >
      {/* BlueGenAI Logo */}
      <div className={`flex items-center justify-center ${classes.icon}`}>
        <Icon name={IconName.Logo} size={classes.iconSize} />
      </div>

      {/* Three-dot loader animation */}
      <LoadingDots />
    </Container>
  );
};

